import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchiveIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.531 11.082H10.443",
			stroke: "#EF4444",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 7.26562V17.5899C4 19.799 5.79086 21.5899 8 21.5899H16C18.2091 21.5899 20 19.799 20 17.5899V7.3136",
			stroke: "#EF4444",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.04111,
			y: 3.58984,
			width: 19.8917,
			height: 3.74628,
			rx: 1.87314,
			stroke: "#EF4444",
			strokeWidth: 1.5
		})
	]
});
export default SvgArchiveIcon;
